import { DateTime } from 'luxon';
import { formatDate } from '@startuptools/ui/format-date';
import { GqlFiscalYear } from '../graphql/base-types.graphql';

export const fiscalYearDisplay = (fiscalYear: GqlFiscalYear, locale: string) => {
  const [start, end] = fiscalYear.split('To');

  return (
    formatDate(DateTime.fromFormat(start!, 'MMM', { locale: 'en' }).startOf('month'), {
      format: { month: 'long', day: 'numeric' },
      locale,
    }) +
    ' - ' +
    formatDate(DateTime.fromFormat(end!, 'MMM', { locale: 'en' }).endOf('month'), {
      format: { month: 'long', day: 'numeric' },
      locale,
    })
  );
};
